import React, { useState, useEffect, useContext} from 'react';
import { Box, Typography, Button, Stack, TextField } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../../contexts/AuthContext';
import { setSnackDetails, setMetaData, setGeneral, setSweetAlert } from '../../service/actions/common';
import axios from 'axios';

import { useFormik } from 'formik';
import * as yup from 'yup';

const validationSchema = yup.object({
    gpt_prompt: yup
        .string('GPT Prompt Editor')
        .required('*Please enter a GPT Prompt to create AI generated reports with')
    });

const GptPrompts = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { token, user } = useContext(AuthContext);
    const [isEdit, setIsEdit] = useState(false);
    const general = useSelector((state) => state.general);
    const metaData  = {
        title: `GPT Prompts | Inspect Reply AI`,
        description: `GPT Prompts | Inspect Reply AI`
    };
    const catchError = async (error) => {
        if (error.response) {
            if (error.response.status === 401) {
                navigate('/sign-in');
            } else if (error.response.status >= 500) {
                dispatch(setSweetAlert({ open: true, title: 'Server Error', text: '' }));
            } else if (error.response.status === 400) {
                dispatch(setSnackDetails({openState : true, message : error.response.data.message, severity : 'error'}));
                return false;
            } else {
                dispatch(setSweetAlert({ open: true, title: 'Error', text: '' }));
            }
        } else if (error.request) {
            dispatch(setSweetAlert({ open: true, title: 'Connection Lost', text: '' }));
        } else {
            dispatch(setSweetAlert({ open: true, title: 'Error', text: 'An unknown error occurred.' }));
        }
    };

    const fetchGtpPrompt = async () => {
        if (user && token) {
            try {
                let uri = `/general`;
                const response = await axios.get(uri, {
                    headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                    },
                });
                dispatch(setGeneral(response.data));
            } catch (error) {
                catchError();
            }
        }
    };
    useEffect(() => {
        fetchGtpPrompt();
        dispatch(setMetaData(metaData));
        // eslint-disable-next-line
    }, []);

    const formik = useFormik({
        initialValues: {
            general_id: general?._id,
            gpt_prompt: general?.gpt_prompt
        },
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            try {
                if (user && token ) {
                    const response = await axios.post('/update-gpt-prompt', values, {
                        headers: {
                            'Authorization': `Bearer ${token}`
                        },
                    });
                    if (response.status === 200) {
                        dispatch(setGeneral(response.data.general));
                        dispatch(setSnackDetails({openState : true, message : response.data.message, severity : 'success'}));
                        setIsEdit(false);
                    } else {
                        dispatch(setSnackDetails({openState : true, message : response.data.message, severity : 'error'}));
                    }
                } else {
                    console.log('unauthorized');
                }
            } catch (error) {
                catchError(error);
            }
        },
    });

  return (
    <Box>
        <Stack direction="row" justifyContent="flex-start" sx={{ width: '100%' }}>
            <Typography variant="h4">GPT Prompts</Typography>
            { isEdit ? (
            <Button color="primary" variant="contained" onClick={formik.handleSubmit} sx={{ borderRadius: 28, ml: "auto" }} >
                Save
            </Button>
            ) : (
            <Button color="primary" variant="outlined" onClick={(e) => {setIsEdit(true)}} sx={{ borderRadius: 28, ml: "auto" }} >
                Edit
            </Button>
            )}
        </Stack>
        <Box
            sx={{
                margin: 'auto',
                padding: 2,
                gap: 2,
                border: '1px solid #ddd',
                borderRadius: 2,
                boxShadow: 1,
                mt:2,
                backgroundColor:'#FFF'
            }}
        >
        { isEdit ? (
        <Stack spacing={2} sx={{ height: '70vh' }}>

            <TextField
                id="gpt_prompt"
                label="GPT Prompts"
                name="gpt_prompt"
                multiline
                rows={20}
                maxRows={Infinity}
                variant="outlined"
                value={formik.values.gpt_prompt}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.gpt_prompt && Boolean(formik.errors.gpt_prompt)}
                helperText={formik.touched.gpt_prompt && formik.errors.gpt_prompt}
            />
        </Stack>
        ) : (
            <Stack direction="column" justifyContent="center" spacing={2} sx={{ mx:2, mt:2, height:'70vh' }}>
                <Box component="section" sx={{ p: 2, border: '1px solid grey', height:'70vh', width: '100%', borderRadius: 1, overflowY: 'auto' }}>
                    <Typography variant="p" sx={{ fontWeight: 'bold' }}>{general?.gpt_prompt}</Typography>
                </Box>
            </Stack>
        )}
    </Box>
    </Box>
  );
};

export default GptPrompts;